import React, { FC, useEffect, useState } from 'react';
import { useMatch, useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { PublicUserProfileFragment, SearchSortDirections, SearchSortFields } from 'api';
import * as paths from 'paths';
import { Layouts } from 'components';
import { useFollowed } from 'hooks';

import { FilterSelect, QueryList } from '../components';

type Params = {
  department_id: string;
  location_id: string;
};

const RESULTS_FROM = 0;
const SIZE = 12;

const TeamIndex: FC = () => {
  const params = useParams<Params>();
  const { users } = useFollowed();
  const [followedUsers, setFollowedUsers] = useState<PublicUserProfileFragment[]>([]);

  const isIndex = !!useMatch(paths.team);
  const isEveryone = !!useMatch(paths.teamEveryone);
  const isDepartmentFilter = !!useMatch(paths.teamDepartment);
  const isLocationFilter = !!useMatch(paths.teamLocation);

  const filterVariables = {
    results_from: RESULTS_FROM,
    size: SIZE,
  };

  useEffect(() => {
    if (isEmpty(followedUsers)) {
      setFollowedUsers(users);
    }
  }, [users]);

  let main = null;

  if (isIndex) {
    const variables = { ...filterVariables, auto_exclude: true };
    main = <QueryList emptyStateName="peopleRecommended" variables={variables} />;
  }

  if (isEveryone) {
    const variables = {
      ...filterVariables,
      auto_exclude: false,
      sort: SearchSortFields.Title,
      sort_direction: SearchSortDirections.Asc,
    };
    main = <QueryList emptyStateName="searchUsers" variables={variables} />;
  }

  if (isDepartmentFilter) {
    const { department_id } = params;
    const variables = { ...filterVariables, required_department_id: department_id };

    main = <QueryList emptyStateName="peopleDepartments" variables={variables} />;
  }

  if (isLocationFilter) {
    const { location_id } = params;
    const variables = { ...filterVariables, required_location_id: location_id };

    main = <QueryList emptyStateName="peopleLocations" variables={variables} />;
  }

  return <Layouts.App2Column mainWidth="wide" sidebar={<FilterSelect />} main={main} />;
};

export default TeamIndex;
